import { Link } from "react-router-dom";
import React, { useState } from "react";

import "./Nav.scss";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className={`nav_bar ${isOpen ? "nav_bar--open" : ""}`}>
      <button
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation"
        aria-expanded={isOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className="nav-list passion-one-regular">
        <li className="nav_item about">
          <Link to="/VersusCX" onClick={closeMenu}>
            Versus CX
          </Link>
        </li>

        <li className="nav_item events">
          <Link to="/Events" onClick={closeMenu}>
            Events
          </Link>
        </li>

        <li className="nav_item donate">
          <Link to="/Support" onClick={closeMenu}>
            Support
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;